var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("img", {
    staticClass: "icon icon-svg",
    attrs: { src: require("@/static/svg/icon_happy.svg"), alt: "Happy face" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }